import { Component, Input } from '@angular/core';

interface FlagOption {
  value: string;
  label: string;
  description: string;
}

@Component({
  selector: 'itfg-ecr-flag-display',
  templateUrl: './flag-display.component.html',
  styleUrls: ['./flag-display.component.scss'],
  standalone: false
})
export class EcrFlagDisplayComponent {
  @Input() flags: string[] = [];

  private flagMapping: Record<string, FlagOption> = {
    'Q1': {
      value: 'Q1',
      label: 'Цесия',
      description: 'Цесия'
    },
    'Q2': {
      value: 'Q2',
      label: 'КПП',
      description: 'Кредит по правителствена програма'
    },
    'Q3': {
      value: 'Q3',
      label: 'Синдикиран',
      description: 'Инструментът е по синдикиран договор'
    },
    'Q4': {
      value: 'Q4',
      label: 'Трети лица',
      description: 'Дължим към трети лица. Инструмент, който отчетната единица обслужва и администрира от името на трети лица, без да носи крайния кредитен риск'
    },
    'Q5': {
      value: 'Q5',
      label: 'Проектно финансиране',
      description: 'Кредит за проектно финансиране.'
    },
    'Q6': {
      value: 'Q6',
      label: 'Неоторизиран овърдрафт',
      description: 'Неоторизиран овърдрафт.'
    },
    'Q7': {
      value: 'Q7',
      label: 'Възстановен кредит',
      description: 'Възстановен кредит.'
    },
    'Q8': {
      value: 'Q8',
      label: 'Мултипродуктов инструмент',
      description: 'Инструментът е част от мултипродуктов инструмент. Във "Вид на кредитен лимит" е отчетен като "Подлимит".'
    },
    'Q9': {
      value: 'Q9',
      label: 'Преструктуриран кредит',
      description: 'С инструмента е рефинансиран необслужван кредит на същата отчетна единица.'
    }
  };

  getFlagInfo(flag: string): FlagOption | undefined {
    return this.flagMapping[flag];
  }
}